import * as React from 'react';
import { TextArea, TextAreaProps } from '../../inputs/TextArea';
import { FormField, formFieldValidationHelper } from '../FormField';

type TextAreaFieldProps = Omit<TextAreaProps, 'inErrorState' | 'onChange'> & {
    label:string,
    infoMessage?:string,
    errorMessage?:string,
    reserveMessageSpace?:boolean,
    validator?:(value:string)=> { valid:true } | {valid:false, errorMessage:string},
    onChange?:(value:string, isValid:boolean)=>void
};

// If errormessage is set, will display error
// else, validator is used
// else, no error is displayed

export function TextAreaField(props:TextAreaFieldProps)
{
    const validation = formFieldValidationHelper(props.value, props.infoMessage, props.errorMessage, props.validator);

    function handleChange(value:string)
    {
        props.onChange?.(value, !validation.inErrorState);
    }

    return (
        <FormField 
            reserveMessageSpace={props.reserveMessageSpace}
            label={props.label} 
            inputComponent={
                <TextArea {...props} inErrorState={validation.inErrorState} onChange={handleChange} />
            } 
            inErrorState={validation.inErrorState}
            message={validation.message}
        />
    )
}